var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.WsButton,_vm._g(_vm._b({staticClass:"cmp-remove-btn",attrs:{"flat":"","icon":"trash","label":_setup.props.label ? 'wsk.general.remove' : undefined,"tooltip":!_setup.props.label ? 'cart.remove_item_hint' : undefined,"text-color":_setup.props.textColor}},'ws-button',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }